import { Component, OnInit, Input } from '@angular/core';
import { PlayerService } from '../../../services/player.service';
import { Player } from '../../../objects/player';
import { GroupService } from '../../../services/group.service';
import { MessageService } from '../../../services/email.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
//import * as Font from '@ckeditor/ckeditor5-font'; 


@Component({
  selector: 's18-email-composer',
  templateUrl: './email-composer.component.html',
  styleUrls: ['./email-composer.component.scss']
})
export class EmailComposerComponent implements OnInit {
  @Input() groupId?: number;
  @Input() playerId?: number;
  @Input() groupEventId?: number;

  public Editor = ClassicEditor;
 

  sending: boolean = false;
  htmlContent: string = '';
  senderEmail: string;
  subject: string;
  player: Player;
  message: string;
  groupAdmins: {
    email: string;
    first: string;
    last: string;
    player_id: string;
  }[];

  constructor(
    private playerService: PlayerService,
    private groupService: GroupService,
    private emailService: MessageService
  ) { }

  ngOnInit() {
    this.player = this.playerService.getLoggedInPlayerInfo();
    if (this.groupId) {
      this.groupService.getGroupAdmins(this.groupId.toString())
        .subscribe(resp => {
          //console.log(JSON.parse(resp.d));
          this.groupAdmins = JSON.parse(resp.d);
        });
    }
  }

  send() {
    this.sending = true;
    if (this.groupEventId) {
      this.sendParticipantEmail();
    } else if (this.groupId) {
      this.sendGroupEmail();
    } else if (this.playerId) {
      this.sendPlayerEmail();
    }
  }

  sendParticipantEmail() {
    this.emailService.sendParticipantEmail(this.groupEventId.toString(), this.senderEmail, this.subject, this.htmlContent)
      .subscribe(resp => {
        this.sending = false;
        var response = JSON.parse(resp.d).response;
        if (response === '') {
          this.message = 'Message sent!';
        } else {
          this.message = response;
        }
        this.clearForm();
      }, resp => { this.sending = false; this.message = 'Could not send message!' });
  }


  sendGroupEmail() {
    this.emailService.sendGroupEmail(this.groupId.toString(), this.senderEmail, this.subject, this.htmlContent)
      .subscribe(resp => {
        this.sending = false;
        var response = JSON.parse(resp.d).response;
        if (response === '') {
          this.message = 'Message sent!';
        } else {
          this.message = response;
        }
        this.clearForm();
      }, resp => { this.sending = false; this.message = 'Could not send message!' });
  }

  sendPlayerEmail() {
    this.emailService.sendPlayerEmail(this.playerId.toString(), this.player.email, this.subject, this.htmlContent)
      .subscribe(resp => {
        this.sending = false;
        var response = JSON.parse(resp.d).response;
        if (response === '') {
          this.message = 'Message sent!';
        } else {
          this.message = response;
        }
      }, resp => { this.sending = false; this.message = 'Could not send message!' });

  }


  clearForm() {
    this.htmlContent = '';
    this.subject = '';
  }

}
